module.exports = __webpack_public_path__ + "img/project_13.e3acb802.png";